import { useGetAttendanceLogsMutation } from "src/services/attendanceServices";
import { Button, Flex, Spin, Timeline } from "antd";
import React, { useEffect } from "react";
import { useNavigate, useParams } from "react-router-dom";
import {
  HeadingSubtitleStyled,
  LargeHeadingStyled,
  SectionHeaderStyled,
} from "src/components/custom/texts/texts.styled";
import TimelineCustom from "src/components/custom/timeline/timeline";
import { getTeacherAttendanceAutoservicePage } from "../../../Api/content";
import { useStrapiContent, renderSectionScheduleSubtitle } from "../../../hooks/useStrapiContent";

function HistorialAttendance() {
  const navigate = useNavigate();
  const { seccionId } = useParams();
  const { content: page } = useStrapiContent(getTeacherAttendanceAutoservicePage);
  const [getAttendanceLogs, { data, isLoading }] = useGetAttendanceLogsMutation();

  useEffect(() => {
    getAttendanceLogs(seccionId);
  }, [getAttendanceLogs, seccionId]);

  return (
    <Flex style={{ flexDirection: "column", width: "100%", alignSelf: "flex-start" }}>
      {isLoading ? (
        <Spin spinning />
      ) : (
        <>
          <SectionHeaderStyled>
            <div>
              <LargeHeadingStyled>
                {page?.history_title_prefix || "Cambios en asistencia del curso"}{" "}
                {data?.info?.nombre}
              </LargeHeadingStyled>
              <HeadingSubtitleStyled>
                {renderSectionScheduleSubtitle(page, data?.info?.seccion, data?.info?.horario)}
              </HeadingSubtitleStyled>
            </div>
            <Button onClick={() => navigate(-1)}>{page?.back_button || "Volver atrás"}</Button>
          </SectionHeaderStyled>

          <div style={{ paddingTop: "10px" }}>
            <Timeline
              items={data?.logs?.map((item: any, index: number) => ({
                children: (
                  <div key={index}>
                    <TimelineCustom data={[item]} />
                  </div>
                ),
              }))}
            />
          </div>
        </>
      )}
    </Flex>
  );
}

export default HistorialAttendance;
